import React, {FC, Suspense} from 'react'
import {Route, RouteComponentProps, Switch} from 'react-router-dom'

import PageLoader from '@progyny/components/PageLoader'
import NotFoundPage from '@progyny/pages/404'
import {useMeStore} from '@progyny/store/meStore'

const Budget = React.lazy(() => import('@progyny/pages/Budget'))
const Reimbursement = React.lazy(
  () => import('@progyny/pages/Budget/Reimbursement')
)

const History = React.lazy(() => import('@progyny/pages/Budget/History'))
const RequestOverview = React.lazy(
  () => import('@progyny/pages/Budget/History/RequestOverview')
)

const Wallet = React.lazy(() => import('@progyny/pages/Budget/Wallet'))
const AddCardWalkthrough = React.lazy(
  () => import('@progyny/pages/Budget/Wallet/AddCardWalkthrough')
)

const BudgetRoutes: FC<RouteComponentProps> = ({match}) => {
  const user = useMeStore((s) => s.user)

  return (
    <Suspense fallback={<PageLoader position={'center'} />}>
      <Switch>
        <Route path={`${match.url}/reimbursement`} component={Reimbursement} />
        <Route exact path={`${match.url}/history`} component={History} />
        <Route path={`${match.path}/history/:id`} component={RequestOverview} />
        <Route exact path={`${match.url}/`} component={Budget} />
        {user?.member?.contract?.enableWallets && (
          <>
            <Route exact path={`${match.url}/wallet`} component={Wallet} />
            <Route
              exact
              path={`${match.url}/wallet/add-card`}
              component={AddCardWalkthrough}
            />
          </>
        )}
        <Route path={`${match.url}/*`} component={NotFoundPage} />
      </Switch>
    </Suspense>
  )
}

export default BudgetRoutes
